import styled from 'styled-components'

export const CompanyImgWrap = styled.section<{
  $mini?: boolean
  $large?: boolean
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${(p) => {
    if (p.$mini) {
      return '38px'
    }
    if (p.$large) {
      return '140px'
    }
    return '48px'
  }};
  height: ${(p) => {
    if (p.$mini) {
      return '38px'
    }
    if (p.$large) {
      return '140px'
    }
    return '48px'
  }};
  overflow: hidden;
  border-radius: 50%;
`

export const CompanyImg = styled.img<{ loadingInProgress: boolean }>`
  width: 100%;
  height: 100%;
  object-fit: cover;

  ${({ loadingInProgress }) =>
    loadingInProgress &&
    `filter: grayscale(100);
     opacity: 0.3;`}
`
export const UploaderContainer = styled.div`
  width: 140px;
  height: 140px;
  display: flex;
  position: absolute;
`
